// src/_Themes/_ThemeProvider.js
import React, { createContext, useContext, useState, useMemo, useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';

const ThemeContext = createContext();
export const useThemeContext = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState('light');

  useEffect(() => {
    const savedMode = localStorage.getItem('themeMode');
    if (savedMode === 'light' || savedMode === 'dark') setMode(savedMode);
  }, []);

  const toggleTheme = () => {
    setMode(prev => {
      const newMode = prev === 'light' ? 'dark' : 'light';
      localStorage.setItem('themeMode', newMode);
      return newMode;
    });
  };

  const theme = useMemo(() => createTheme({
    palette: { mode }
  }), [mode]);

  // تطبيق الخلفية والنص على body تلقائيًا
  useEffect(() => {
    document.body.style.backgroundColor = theme.palette.background.default || (mode === 'dark' ? '#121212' : '#f0f2f5');
    document.body.style.color = theme.palette.text.primary || (mode === 'dark' ? '#f0f2f5' : '#000000');
  }, [theme, mode]);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  );
};
